import React, { Component } from 'react';
import { ObtenirDetailsAvance } from '../../App_Code/API';
import { toEuros } from '../../App_Code/Utils';
import Chargement from '../Chargement';
import Tableau from '../Tableau';

const MontantAvance = ({ total, fondsTvx, autreFonds }) => (
    <div className="w-75 mb-5">
        <div className="row font-weight-bold" style={{ fontSize: '1.4rem' }}>
            <span className="col-7">Mon avance détenue</span>
            <span className="col-5 text-right">{`${toEuros(total, true)} €`}</span>
        </div>
        <span>dont :</span>
        <ul className="w-100">
            <li className="row text-success font-weight-bold">
                <span className="col-7">- Fonds de travaux</span>
                <span className="col-5 text-right">{`${toEuros(fondsTvx, true)} €`}</span>
            </li>
            <li className="row text-primary font-weight-bold">
                <span className="col-7">- Autres avances détenues</span>
                <span className="col-5 text-right">{`${toEuros(autreFonds, true)} €`}</span>
            </li>
        </ul>
    </div>
);

const AvanceDetails = ({ lsAva, lsLot }) => {
    function cacherColonne(index) {
        return lsLot.reduce((total, lot) => total + lot.lsMontantAva[index], 0) === 0;
    }

    const Entete = (
        <tr>
            <th scope="col" className="align-middle text-left" style={{ minWidth: 300 }}>Lot</th>
            <th scope="col" className="align-middle text-right" style={{ minWidth: 100 }}>Total</th>
            {lsAva.map((item, key) =>
                (<th scope="col" className="text-center" style={{ minWidth: 250 }} hidden={cacherColonne(key)}>
                    <span>{item.Num} - {item.Code}</span><br />
                    <span><small>{item.Libelle}</small></span>
                 </th>))}
        </tr>
    );

    const Lignes = lsLot.map(item =>
        (<tr>
            <td>{item.Num} - {item.Libelle}</td>
            <td className="text-right align-middle">{toEuros(item.TotalLot, true)}</td>
            {
                item.lsMontantAva.map((montant, key) =>
                    (<td className=" text-center align-middle" hidden={cacherColonne(key)}>
                        <p className={lsAva[key].FondsTvx ? 'text-success text-right' : 'text-primary text-right'} style={{ width: '60%', margin: 0 }}>
                            {toEuros(montant, true)}
                        </p>
                    </td>))
            }
         </tr>));

    const Pied = (
        <tr className="table-secondary">
            <th>TOTAUX</th>
            <th className="text-right align-middle">{toEuros(lsLot.reduce((total, lot) => total + lot.TotalLot, 0), true)}</th>
            {
                lsAva.map((ava, key) =>
                    (<th className={ava.FondsTvx ? 'text-success text-right' : 'text-primary text-right'} hidden={cacherColonne(key)}>
                        <p className="text-right" style={{ width: '60%', margin: 0 }}>
                            {toEuros(lsLot.reduce((total, lot) => total + lot.lsMontantAva[key], 0), true)}
                        </p>
                    </th>))
            }
        </tr>
    );

    return (
        <React.Fragment>
            <span className="col-7 font-weight-bold" style={{ fontSize: '1.4rem' }}>Détails</span>
            <Tableau Entete={Entete} Lignes={Lignes} Pied={Pied} />
        </React.Fragment>
    );
};


class PageDetailsAvance extends Component {
    state = {
        data: null,
    };

    componentWillMount() {
        ObtenirDetailsAvance().then((ava) => {
            this.setState({ data: ava.data });
        });
    }

    render() {
        const { data } = this.state;
        if (data === null) return <Chargement />;

        return (
            <React.Fragment>
                <MontantAvance total={data.AvaTvx + data.AvaAutres} fondsTvx={data.AvaTvx} autreFonds={data.AvaAutres} />
                <AvanceDetails lsAva={data.LsCptAva} lsLot={data.LsAvaLots} />
            </React.Fragment>
        );
    }
}
PageDetailsAvance.displayName = 'PageDetailsAvance';


export default PageDetailsAvance;



// WEBPACK FOOTER //
// ./src/components/MesInfos/PageDetailsAvance.js